// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useEffect, useRef } from 'react';

/**
 * This hook gives the value of any variable from the previous render invocation
 */
export const usePrevious = <T>(value: T) => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};



// WEBPACK FOOTER //
// /local/home/vibhorbh/src/internal/hooks/use-previous/index.ts